export default "__VITE_ASSET__BI3XBu_S__"